var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CertificatePage',{attrs:{"page":_vm.page,"list":_vm.list,"stats":_vm.stats}})
}
var staticRenderFns = []

export { render, staticRenderFns }